import { CATEGORY_LIST, META_DATA } from '../utils/constants';
import {
  ButtonAbout,
  ButtonCategory,
  ButtonKangourou,
  DescriptionBook,
  Dscription,
  IconHexagon,
  ItemOption,
  MainContent,
  NameCategory,
  NewInfo,
  TitleBook,
  WrapperBook,
  WrapperCategory,
  WrapperCategoryDescription,
  WrapperImg,
  WrapperNotification,
  WrapperSteps,
} from './Home.styled';
import logoCangourou from '../assets/images/kangourou.png';
import book1 from '../assets/images/book.jpg';
import book2 from '../assets/images/NumberPuzzles.jpg';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { handleScrollUp } from '../utils/helpers';
import { Button } from '@mui/material';

// import { withoutObjId, changeId } from '../utils/deleteObjectId';
// import quiz from '../utils/quiz.json';
// import mongodbTasks from '../utils/mongodbTasks.json';
// console.log(withoutObjId(quiz.tasks));
// console.log(changeId(mongodbTasks));

const Home = () => {
  const { title, description, keywords } = META_DATA?.home;

  useEffect(() => {
    handleScrollUp();
    localStorage.clear();
  }, []);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="keywords" content={keywords} />
        <meta name="description" content={description} />
      </Helmet>

      <MainContent>
        <WrapperCategory>


          <WrapperNotification elevation={3}>
            <NewInfo>Novità! Quiz Rapido</NewInfo>
            <b>Senza registrazione per gli studenti</b>
            <WrapperSteps>
              <ItemOption>
                <IconHexagon />
                Registrati come insegnante
              </ItemOption>
              <ItemOption>
                <IconHexagon />
                Crea una classroom
              </ItemOption>
              <ItemOption>
                <IconHexagon />
                Crea il tuo <b>quiz rapido</b>
              </ItemOption>
              <ItemOption>
                <IconHexagon />
                Copia e condividi il link con gli studenti
              </ItemOption>
              <ItemOption>
                <IconHexagon />
                Monitora i risultati
              </ItemOption>
              <ItemOption>
                <IconHexagon />
                Il quiz sarà disponibile per <b>15 giorni</b>
              </ItemOption>
            </WrapperSteps>
            <Button component={Link} variant="contained" color="benjamin" to="/register">registrati</Button>
          </WrapperNotification>

          <WrapperCategoryDescription>
            <ButtonKangourou component={Link} to="/simulation">
              <img
                src={logoCangourou}
                width="70"
                height="70"
                alt="Logo Kangourou"
              />
            </ButtonKangourou>
            <Dscription>
              <NameCategory>simulazione: </NameCategory>
              allenati con le edizioni precedenti di Kangourou
            </Dscription>
          </WrapperCategoryDescription>

          {CATEGORY_LIST.map(({ category, description }) => {
            return (
              <WrapperCategoryDescription key={category}>
                <ButtonCategory
                  component={Link}
                  to={`/${category}`}
                  color={category}
                  variant="contained"
                >
                  {category[0]}
                </ButtonCategory>
                <Dscription>
                  <NameCategory>{category}: </NameCategory>
                  {description}
                </Dscription>
              </WrapperCategoryDescription>
            );
          })}

          <WrapperCategoryDescription>
            <ButtonAbout
              component={Link}
              to="/about"
              color="base"
              variant="contained"
            >
              about
            </ButtonAbout>
            <Dscription>
              <NameCategory>mathlab: </NameCategory>
              la nostra missione
            </Dscription>
          </WrapperCategoryDescription>

          <WrapperBook>
            <TitleBook>I consigli di mathlab.it</TitleBook>
            <DescriptionBook>              
              <NewInfo>1. A volte basta un piccolo esercizio per accendere una grande curiosità!</NewInfo>
              <span>📘 Questo libro <b>in inglese</b>, pensato per <b>bambini 8–10 anni</b>,
              trasforma la matematica in un gioco di scoperte:</span>
              <span>🔍 logica che si apre;</span>
              <span>💡 intuizione che cresce;</span>
              <span>🌱 fiducia che nasce pagina dopo pagina.</span>
              <img
                src={book1}
                alt="Libro di matematica in inglese per bambini 8–10 anni"
              />
                <Button
                component={Link}
                to="https://amzn.to/4jgDVdP"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Scopri il libro su Amazon"
              >
                👉 Scopri il libro su Amazon</Button>
              <span>💛 Lo raccomandiamo a chi desidera accompagnare i più piccoli
                verso un rapporto <b>sereno e curioso</b> con la matematica, fin dai primi passi.</span>

            </DescriptionBook> 
            <DescriptionBook>
              <NewInfo>2. Un viaggio tra numeri, strategie e intuizioni!</NewInfo>
              <span>📘 Pubblicato da <b>Oxford University Press</b>, questo libro <b>in inglese</b> pensato per <b>bambini 8–11 anni</b> propone una raccolta di quesiti che stimolano logica, strategia e capacità di osservazione.</span>
              <span>🧠 sfide progressive per allenare il ragionamento;</span>
              <span>🌍 un modo semplice e naturale per <b>migliorare anche l’inglese</b>;</span>
              <span>🚀 attività ideali per sviluppare un solido <b>problem solving</b>.</span>
              <WrapperImg>
                <img src={book2} alt="Libro di puzzle numerici in inglese per bambini 8–11 anni" />
              </WrapperImg>              
              <Button component={Link} to="https://amzn.to/4qDV188" target="_blank" rel="noopener noreferrer" aria-label="Scopri il libro su Amazon" > 👉 Scopri il libro su Amazon </Button>
            </DescriptionBook>
          </WrapperBook>
        </WrapperCategory>
      </MainContent>
    </>
  );
};

export default Home;
